import React, { useMemo } from 'react';
import ExecutionHistory from '../../components/ExecutionHistory';
import AliasNavigationContextProvider from '../../components/Builder/AliasNavigation';
import { Outlet, useParams } from 'react-router-dom';
import useFormulaConfigWeekStartEffect from './utils/useFormulaConfigWeekStartEffect';
import useUnmountFormulasEffect from './utils/useUnmountFormulasEffect';
import useQueryTypeFromLocation from '../../utils/routes/useQueryTypeFromLocation';
import useCheckFeatureEffect from './utils/useCheckFeatureEffect';
import { Feature } from '../../utils/apollo/graphqlSchema';
import { appRoutes } from '../../path';
import { BuilderContextProvider } from '../../components/Builder/BuilderContext';
import { useFormulaPageViewedEffect } from './utils/useFormulaPageViewedEffect';
import { analysisSelector } from '../../redux/selectors/analyses';
import { useAppSelector } from '../../redux/hooks';

const Formulas = () => {
  const urlParams = useParams();
  const builderId = urlParams?.builderId;
  const queryType = useQueryTypeFromLocation();

  useFormulaConfigWeekStartEffect();
  useCheckFeatureEffect(Feature.Prediction, appRoutes.report.prediction);
  useCheckFeatureEffect(Feature.Significance, appRoutes.report.significance);
  useUnmountFormulasEffect();
  useFormulaPageViewedEffect(queryType, builderId);

  const currentAnalysisMemoizedSelector = useMemo(analysisSelector, []);
  const currentAnalysis = useAppSelector((state) =>
    currentAnalysisMemoizedSelector(state, builderId),
  );
  // if the schema is disabled then the builder should be hidden
  const isSchemaDisabled = currentAnalysis?.metadata?.query.schema.disabled;
  // When there is only /report in URL - we don't have to render anything
  if (!queryType) {
    return null;
  }

  return (
    <AliasNavigationContextProvider>
      <BuilderContextProvider>
        {!isSchemaDisabled && <Outlet />}
        {builderId && <ExecutionHistory builderId={builderId} />}
      </BuilderContextProvider>
    </AliasNavigationContextProvider>
  );
};

export default Formulas;
